import styled from "styled-components"
import { maxWidth, when } from "utils"
import GeneralCard from "../base"

export const Card = styled(GeneralCard)`
  position: relative;
  min-height: 34rem;

  ${maxWidth.mobile`
    ${({ isGrid }) => isGrid && "min-width: 80vw;"}
  `}

  h3 {
    font-size: 2.8rem;
  }

  > :nth-child(2) {
    padding: 3rem;
    border-radius: 0.6rem;
    background-color: #fff;

    ${when("background")`
      background-image: url(${(props) => props.background});
      background-repeat: no-repeat;
      background-size: 10.3rem 10.3rem;
      background-position: 100% 100%;
    `}
  }
`

export const Preheading = styled.div`
  color: #767676;
  text-transform: uppercase;
  font-size: 1.4rem;
  font-weight: 500;
  letter-spacing: 0.15rem;

  p {
    margin: 0;
  }
`
